module.exports = __webpack_public_path__ + "static/media/penedo-partitura-0.a6df1335.png";